import { matchPath } from "react-router-dom";
import { schoolRouteConfig } from "./SchoolRouteConfig";

export const getSchoolRouteInfo = (pathname) => {
  for (const route in schoolRouteConfig) {
    const match = matchPath({ path: route, end: true }, pathname);
    if (match) {
      return schoolRouteConfig[route];
    }
  }

  return {
    pageTitle: "",
    breadcrumbs: []
  };
};
